const CookieUtils = {
  setCookie(cname, cvalue, exdays = 30) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${cname}=${JSON.stringify(cvalue)}; ${expires}`;
  },
  getCookie(cname) {
    if (cname) {
      const name = `${cname}=`;
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          const value = JSON.parse(c.substring(name.length, c.length));
          this.setCookie(cname, value, 30); // auto extends expiry
          return value;
        }
      }
    }
    return '';
  },
};

export default CookieUtils;
